export enum DataFetchingState {
  FAILED = 'FAILED',
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED',
}
